import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const About = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ p: 4, color: '#ffffff', textAlign: 'center', backgroundColor: '#1a1a1a', maxWidth: '800px', margin: '0 auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button variant="contained" onClick={() => navigate('/')} startIcon={<ChevronLeftIcon />} sx={{ backgroundColor: '#2a2a2a', color: '#ffffff', width: '90px' }}>
          Back
        </Button>
        <Typography variant="h4" sx={{ fontWeight: 'bold', flexGrow: 1, textAlign: 'center' }}>
          About Us
        </Typography>
        <Box sx={{ width: '90px' }} />
      </Box>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Welcome to our platform, designed to revolutionize how developers and teams tackle app development and project management. With features like one-click Expo Go previews, seamless Vercel deployments, and effortless GitHub integration, we simplify even the most complex workflows for maximum efficiency.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Discover the advantage of intelligent code suggestions and robust project management tools, all in a single, user-friendly interface. Whether you're previewing apps in real-time, managing repositories, or automating deployments, our platform helps you focus on delivering exceptional results.
      </Typography>
      <Typography variant="body1">
        By combining advanced tools with streamlined processes, we empower developers at every level to work smarter, faster, and more collaboratively. Join us in shaping the future of development.
      </Typography>

    </Box>
  );
};

export default About;